import React, { useState } from 'react'
import { PlayIcon } from './Icons'

export function ImageItem({ item, onClick }) {
  const [imageLoaded, setImageLoaded] = useState(false)
  const isVideo = item.vimeo_id && item.vimeo_id !== ''
  
  return (
    <div className="image-item" onClick={() => onClick(item)}>
      <div className="image-item__thumbnail">
        {isVideo ? (
          <div className="image-item__video-placeholder">
            <img 
              src={`https://vumbnail.com/${item.vimeo_id}.jpg`}
              alt={item.filename}
              onError={(e) => {
                e.target.style.display = 'none'
              }}
              loading="lazy"
            />
            <div className="image-item__play-icon">
              <PlayIcon />
            </div>
          </div>
        ) : (
          <>
            {/* LQIP - Low Quality Image Placeholder */}
            {item.lqip && (
              <img 
                src={item.lqip}
                alt=""
                className={`image-item__lqip ${imageLoaded ? '-hidden' : ''}`}
                aria-hidden="true"
              />
            )}
            {/* Full quality thumbnail */}
            <img 
              src={`assets/expeditions-data/thumbnails/${encodeURIComponent(item.filename)}`}
              alt={item.filename}
              loading="lazy"
              className={`image-item__full ${imageLoaded ? '-loaded' : ''}`}
              onLoad={() => setImageLoaded(true)}
            />
          </>
        )}
      </div>
    </div>
  )
}


